
<style lang="less" scoped>
@import '../../../style/common/variable';
*{list-style-type: none;}
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
i{font-size: 19px;color: #289FDE;}
h3{line-height: 50px;text-align: left;margin:0;font-size: 18px;}
.qyzs{display: flex;width: 1200px; margin: auto;flex-direction: column;margin-top: 40px;}
.head{height: 75px;display: flex;justify-content: space-between;width: 100%;align-items: center;}
.gengduo{line-height: 50px;font-size: 16px;font-weight: 600;cursor: pointer;}
li{width:100%;height: 30px;font-size: 16px;color: #666666;padding-top: 10px;border-bottom: 1px solid #f2f2f2;cursor: pointer;}
li:hover{color:#037cff}
.exhibition{width: 1400px;display: flex; margin: 0;padding: 0;margin-left: -20px;flex-wrap: wrap;
  li{width: 255px;height: 174px;margin: 0px 28px;border-radius: 2px;display: flex;flex-direction: column;background-color: #f7f7f7;margin-bottom: 40px;cursor: pointer;}
}
.hzxm{display: flex;width: 1200px; margin: 10px auto;flex-direction: column;}
.kyxm{margin-bottom: 20px;}
.SwiperGroup{margin-left: 20px;}
.second{position: relative;text-align:left;margin: 0px 0px 40px -20px;overflow: hidden;display: flex;
  .seamless-warp{width: 100%;height: 392px;overflow: hidden;}
  p{width:580px;background-color: #f2f2f2;line-height: 32px;font-size: 20px;margin-left: 40px;}
  ul{list-style: none;}
  span{margin: 0px 20px;}
}
.left{
  .col1{float:left;width:460px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
  .col3{float:right;margin-right: 10px;}
}
.right{
  .col1{float:left;width:340px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
  .col3{float:right;margin-right: 10px;}
}

.hyxx{display: flex;width: 1200px; margin: auto;flex-direction: column;}
.details{position: relative;display: flex;width: 100%;
  .image{
    img{width: 570px;height: 230px;margin-right: 30px;}}
  .prjtext{background: white;height: 230px;
      /deep/.el-tabs__active-bar is-top {width: 80px;}
      /deep/.el-tabs__item {font-size: 20px;}
      /deep/.el-tab-pane{font-size: 17px; text-align: left;line-height: 32px;}
    .first{background: #eee;font-family: Microsoft YaHei;padding: 10px 0px;
      p{margin: 0px 20px 0px 20px;font-size: 24px;color: #000;text-align: left;}
    }
  }
}
.qyname{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.qyimg{width:100%;height:130px}
@media screen and (max-width: @max-screen)
{
  .hyxx{width: 100%;}
  .details{display: flex;flex-direction: column;flex-wrap: wrap;
    .image{
      img{margin-left: 2vw; width: 96vw; height: auto; margin-right: 0;}}
    .prjtext{margin-left: 2vw; width: 96vw; height: auto;}
  }
  .qyzs{width: 95vw;
    .head{width: 95vw;margin: auto;}
    .exhibition{width: 95vw; margin: 0;
      li{width: 100%; height: auto; margin: 0; margin-top: 0.1rem;}
      .qyimg{width:100%; height:2rem}
    }
  }
  .hzxm{width: 95%; overflow: hidden;}
  .second{display: flex; flex-direction: column;margin: 0px;
    ul{margin: 0; padding: 0;}
    p{width: 100%;margin-left: 0px;font-size: 16px;}
    span{margin: 0px 10px;}}
  li{font-size: 12px;display: flex; justify-content: space-around;}
  .right{margin-left: 0px;width: 100%;
    .col2{margin-left: 0px;}
  }
  .left{width: 100%;
    .col1{margin-left: 0px;width:70%;overflow: scroll;display: inline-block;white-space: nowrap;text-overflow: ellipsis;}
    .col2{float:right;margin-right: 10px;}
  }
}
</style>

<template>
  <div class="center">
    <!-- 我要办会 -->
    <div class="holdmeeting hyxx" style="margin-top: 30px;">
      <div class="head">
        <h2>
          <i class="iconfont icon-huiyi2"></i>
          {{hyzjlist.name}}
        </h2>
      </div>
      <div class="details">
        <div class="image">
          <img :src="hyzjlist.thumb" alt="">
        </div>
        <div class="prjtext">
          <el-tabs v-model="activeName" >
            <el-tab-pane label="组织简介" name="first">{{hyzjlist.introduce}}</el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <TabsCardZz :hyzjlist="hyzjlist"></TabsCardZz>
    <!-- 企业展示 -->
    <div class="qyzs">
      <div class="head">
        <h3>
          <i class="iconfont icon-qiye"></i>
          企业展示 / Eenerprise Exhibition
        </h3>
        <span class="gengduo" @click="goQyzhList">更多</span>
      </div>
      <ul class="exhibition">
        <li v-for="(each, index) in exhibition" :key="index" @click="clickCompany(each)" >
          <div class="qyimg">
            <img :src="each.thumb" alt="" style="width:100%;height:100%">
          </div>
          <p class="qyname" style="margin: 10px 10px;">{{each.company}}</p>
        </li>
      </ul>
    </div>
    <!-- 矿业项目\矿业设备\矿产品 -->
    <div class="hzxm">
       <div class="head">
        <h3>
          <i class="iconfont icon-xiangmu"></i>
          矿业项目 / Mining project
        </h3>
        <span class="gengduo" @click="onKyxmList">更多</span>
      </div>
      <CardImgkyxm class="kyxm" :cardImgkyxmList="cardImgkyxmList" @clickImgName="getKyxmDetails"></CardImgkyxm>
      <div class="head">
        <h3>
          <i class="iconfont icon-mineral"></i>
          矿业设备 / Mining equipment
        </h3>
        <span class="gengduo" @click="onKysbList">更多</span>
      </div>
      <SwiperGroup class="SwiperGroup" :swiperGroupList="swiperGroupListSB" @clickSwiper="onclickSwiperSB"></SwiperGroup>
      <div class="head">
        <h3>
          <i class="iconfont icon-yaoji"></i>
          矿业药剂 / Mining medicament
        </h3>
        <span class="gengduo" @click="onKyyjList">更多</span>
      </div>
      <SwiperGroup class="SwiperGroup" :swiperGroupList="swiperGroupListYJ" @clickSwiper="onclickSwiperYJ"></SwiperGroup>
      <div class="head">
        <h3>
          <i class="iconfont icon-zhubao"></i>
          珠宝玉石 / Jewelry and Jade
        </h3>
        <span class="gengduo" @click="onZbysList">更多</span>
      </div>
      <SwiperGroup class="SwiperGroup" :swiperGroupList="swiperGroupListZB" @clickSwiper="onclickSwiperZB"></SwiperGroup>
      <p></p>
      <div class="head">
        <h3>
          <i class="iconfont icon-qiye"></i>
          矿产品 / Mineral products
        </h3>
        <span class="gengduo" @click="onKcpList">更多</span>
      </div>
      <div class="second">
        <div class="left">
          <p><span>供求信息</span></p>
          <vue-seamless-scroll :data="secondLList" class="seamless-warp" :class-option="classOption">
            <ul>
              <li class="DataList_top" v-for="(item,index) in secondLList" :key="index" @click="getKcpDetails(item)">
                <span class="col1"> {{ item.title }} </span>
                <span class="col2"> {{ item.typeid | formatJYLX() }} </span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="right">
          <p><span>热门信息</span></p>
          <vue-seamless-scroll :data="secondRList" class="seamless-warp" :class-option="classOption">
            <ul>
              <li v-for="(item,index) in secondRList" :key="index" @click="getKcpDetails(item)">
                <span class="col1"> {{ item.title }} </span>
                <span class="col2"> {{ item.typeid | formatJYLX() }} </span>
                <span class="col3"> {{ item.time * 1000 | formatDate() }} </span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperYSZT from '.././assembly/SwiperYSZT'
import SwiperImg from '.././assembly/SwiperImg'
import TabsCardZz from '../assembly/TabsCardZz'

import NewsEXhibition from '.././assembly/NewsEXhibition'
import playVideo from '../method/playVideo'
import National from '.././assembly/National'
import MeetingList from '.././assembly/MeetingList.vue'
import CardImgkyxm from '../assembly/CardImgkyxm'
import SwiperGroup from '../assembly/SwiperGroup'
import arrayFun from '../method/array.js'
import filters from '../method/filter.js'
let obj = {}
let meeting = []
let num2 = 1
export default {
  components: {SwiperYSZT, SwiperImg, TabsCardZz, NewsEXhibition, National, MeetingList, CardImgkyxm, SwiperGroup},
  mixins: [playVideo, filters],
  name: '',
  data()
  {
    return {
      newsKYZXLis: [],
      exhibition: [],
      activeName: 'first',
      currentPage: 1,
      flag1: true,
      flag2: false,
      flag3: false,
      flag4: false,
      TabsList: [],
      active: '',
      active1: '近期会议',
      Scheduler: [],
      cardImgkyxmList: [],
      swiperGroupListSB: [],
      swiperGroupListYJ: [],
      swiperGroupListZB: [],
      secondLList: [],
      secondRList: [],
      WybhData: [],
      currentdata: {},
      hyzjlist: {},
      select: 0,
      dataid: null,
      swiperYSZTdata: [
        { pic: 'static/images/JMZT/ZT1.jpg', name: 'ZT1', type: 'VR', title: '展厅3D模型' },
        { pic: 'static/images/JMZT/ZT2.jpg', name: 'ZT2', type: 'VR', title: '展厅3D模型' },
        { pic: 'static/images/JMZT/ZT3.jpg', name: 'ZT3', type: 'VR', title: '展厅3D模型' },
        { pic: 'static/images/JMZT/ZT4.jpg', name: 'Zt4', type: 'VR', title: '展厅3D模型' },
        { pic: 'static/images/JMZT/ZT5.jpg', name: 'ZT5', type: 'VR', title: '展厅3D模型' }
      ],
      hotNewslist: [
        {title: '测试测试测试', text: '测试测试测试测试测试测试'},
        {title: '测试测试测试1', text: '测试测试测试测试测试测试1'},
        {title: '测试测试测试2', text: '测试测试测试测试测试测试2'}
      ]
    }
  },
  computed: {
    player()
    {
      return this.$refs.videoPlayer.player
    },
    NewsKYZXLis()
    {
      return this.newsKYZXLis
    },
    classOption()
    {
      return {
        step: 0.5,
        direction: 1
      }
    },
    Exhibition()
    {
      return this.exhibition
    },
    tabsList()
    {
      return this.TabsList
    },
    scheduler()
    {
      return this.Scheduler
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.dataid = nval.query.id
        this.getHyzjZz(nval.query.id)
        // this.$store.commit('onZzid', nval.query.id)
      },
      immediate: true
    }
  },
  created()
  {
    this.getExhibition()
    this.getPlayerOptions()
    this.getKyxm()
    this.getKcp()
    this.getKysb()
    this.getKyyj()
    this.getZbys()
    this.getHyfb()
    this.getWybhData()
  },
  methods:
  {
    /**
     * 企业展示数据
     */
    getExhibition()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 26, _exp: `level=1 and examine = 0 and organiseid in (${this.dataid}, 0)`, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 8}
      window.post.getPost(paras).then((ret) =>
      {
        this.exhibition = ret[0].data
      })
    },
    /**我要办会-获取所有数据-安进 */
    getWybhData()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 52, _exp: 'id>0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push(item)
        })
        this.WybhData = temp
        this.currentdata = this.WybhData[0]
      })
    },
    // 矿业项目
    getKyxm()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 12, _exp: `id>0 and examine = 0 and organiseid in (${this.dataid}, 0)`, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras).then((ret) =>
      {
        this.cardImgkyxmList = []
        ret[0].data.forEach(item =>
        {
          this.cardImgkyxmList.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, description: '经营范围', text: item.introduce, time: item.addtime, company: item.company})
        })
      })
    },
    // 会员之家组织
    getHyzjZz(val)
    {
      let parass = {cmd: 'query', _major: 11, _minor: 126, _exp: `id = ${val}`, orderby: 'addtime ASC'}
      window.post.getPost(parass).then((ret) =>
      {
        this.hyzjlist = {}
        this.hyzjlist = {id: ret[0].id, name: ret[0].name, thumb: ret[0].thumb, introduce: ret[0].introduce, url: ret[0].url}
      })
    },
    // 矿业设备
    getKysb()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 18, _exp: `id>0 and examine = 0 and organiseid in (${this.dataid}, 0)`, orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        this.swiperGroupListSB = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, time: item.adddate, company: item.company})
        })
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.swiperGroupListSB.push(tempList[i])
      })
    },
    // 矿业药剂
    getKyyj()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 20, _exp: `id>0 and examine = 0 and organiseid in (${this.dataid}, 0)`, orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        this.swiperGroupListYJ = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, time: item.adddate, company: item.company})
        })
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.swiperGroupListYJ.push(tempList[i])
      })
    },
    // 珠宝玉石
    getZbys()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 16, _exp: `id>0 and examine = 0 and organiseid in (${this.dataid}, 0)`, orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        this.swiperGroupListZB = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, time: item.adddate, company: item.company})
        })
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.swiperGroupListZB.push(tempList[i])
      })
    },
    // 矿产品
    getKcp()
    {
      let paras23 = {cmd: 'query', _major: 11, _minor: 14, _exp: `id>0 and examine = 0 and organiseid in (${this.dataid}, 0)`, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras23).then((ret) =>
      {
        let arr = []
        this.secondLList = []
        this.secondRList = []
        ret[0].data.forEach(item =>
        {
          this.visit += item.hits
          arr.push({id: item.id, title: item.title, typeid: item.typeid, time: item.addtime, hits: item.hits, company: item.company})
        })
        this.release += ret[0].data.length
        this.deal = ret[0].data.length // 成交总数

        for (let i = 0; i < 10; i++)
          this.secondLList.push(arr[i]) // 供求信息
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.secondRList.push(tempList[i]) // 热门信息
      })
    },
    /**中国—东盟矿业合作论坛云上展厅-安进 */
    getPlayerOptions()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 56, _exp: 'type=? and shows =1', types: 's', vals: '1', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        this.playerOptions.sources[0].src = ret[0].data[0].video ? ret[0].data[0].video : 'static/images/moren.jpg'
      })
    },
    //获取会议发布列表数据
    getHyfb()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 53, _exp: 'id>0 and examine = 0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        obj = {}
        meeting = []
        meeting = ret[0].data
        ret.forEach(e =>
        {
          let type = e.type
          if (!obj[type])
            obj[type] = []
          obj[type].push(e)
        })
        this.active = Object.keys(obj)[0]
        this.onMeeting()
      })
    },
    /**
     * 会议日历分类
     * @method String active 当前tab选中页
     * @method String click 会议发布项目
     */
    onMeeting(active, click)
    {
      //判断点击加载更多是否属于当前项目
      if (!click === '会议日历')
        return false
      //当前选中的tab页
      if (active)
      {
        this.active1 = active
        num2++
      }
      this.Scheduler = []
      let index = 4 * num2
      let recent = [] //往期
      let period = [] //近期
      meeting.forEach(e =>
      {
        let now = new Date().valueOf()
        let front = now - 1296000000
        let after = now + 1296000000
        let addtime = e.addtime * 1000
        if (front <= addtime && addtime <= after && period.length < index)
        {
          e.A = '近期会议'
          period.push(e)
        }
        else if (addtime < front)
        {
          e.A = '往期会议'
          recent.push(e)
        }
      })
      this.Scheduler.push({title: '近期会议', content: period, cli: '会议日历'}, {title: '往期会议', content: recent, cli: '会议日历'})
    },
    //矿业项目列表页
    onKyxmList()
    {
      let url = this.$router.resolve({path: '/HzxmKYXMList'})
      window.open(url.href, '_blank')
    },
    //矿产品列表页
    onKcpList()
    {
      let url = this.$router.resolve({path: '/HzxmKCPList'})
      window.open(url.href, '_blank')
    },
    //矿业设备列表页
    onKysbList()
    {
      let url = this.$router.resolve({path: '/HzxmKYSBList'})
      window.open(url.href, '_blank')
    },
    //矿业药剂列表页
    onKyyjList()
    {
      let url = this.$router.resolve({path: '/HzxmKYJSList'})
      window.open(url.href, '_blank')
    },
    //珠宝玉石列表页
    onZbysList()
    {
      let url = this.$router.resolve({path: '/HzxmZBYSList'})
      window.open(url.href, '_blank')
    },
    //跳转矿业项目详情页
    getKyxmDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYXMDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿产品详情页
    getKcpDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKCPDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿业设备详情页
    onclickSwiperSB(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYSBDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿业药剂详情页
    onclickSwiperYJ(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYJSDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转珠宝玉石详情页
    onclickSwiperZB(item)
    {
      let url = this.$router.resolve({path: '/HzxmZBYSDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转会议详情召开中
    goHyxqzk(each)
    {
      if (each.A === '近期会议')
      {
        let url = this.$router.resolve({path: '/Hyxqzk', query: {id: each.id}})
        window.open(url.href, '_blank')
      }
      else
      {
        let url = this.$router.resolve({path: '/Hyxqwq', query: {id: each.id}})
        window.open(url.href, '_blank')
      }
    },
    clickCompany(each)
    {
      let url = this.$router.resolve({path: '/CompanyShow', query: {id: each.id}})
      window.open(url.href, '_blank')
    },
    // 跳转到企业展示列表页
    goQyzhList()
    {
      let url = this.$router.resolve({path: '/QyzsList'})
      window.open(url.href, '_blank')
    },
    // 跳转到我要参展报名页
    goChxxb()
    {
      let url = this.$router.resolve({path: '/Chxxb'})
      window.open(url.href, '_blank')
    },
    // 跳转到我要办会报名页
    goBhxxb()
    {
      let url = this.$router.resolve({path: '/Bhxxb'})
      window.open(url.href, '_blank')
    },
    // 跳转到加盟展厅
    goJMZT(name)
    {
      let url = this.$router.resolve({name: 'FictitiousZT', params: {name: name}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/MemberHome.vue